import mitt from 'mitt';
import { Centrifuge } from 'centrifuge';
import api from '../services/api';
import { getCentrifugoWebSocketUrl } from '../services/websocket';

const emitter = mitt();
let centrifuge = null;
const channelSubs = new Map();

async function ensureClient() {
  if (centrifuge) return centrifuge;
  const response = await api.post('/api/centrifugo/token');
  // Interceptor handles unified structure, response.data is already unwrapped
  const token = response.data?.token || response.data;
  if (!token) throw new Error('No Centrifugo connection token');
  centrifuge = new Centrifuge(getCentrifugoWebSocketUrl(), {
    token: token,
    getToken: async () => {
      try {
        const r = await api.post('/api/centrifugo/token');
        // Interceptor handles unified structure, response.data is already unwrapped
        return r.data?.token || r.data;
      } catch (e) {
        console.error('[realtime] getToken error', e);
        return null;
      }
    }
  });
  centrifuge.on('connecting', (ctx) => {
    console.log('[realtime] connecting', ctx);
  });
  centrifuge.on('connected', (ctx) => {
    console.log('[realtime] connected', ctx);
  });
  centrifuge.on('disconnected', (ctx) => {
    console.log('[realtime] disconnected', ctx);
  });
  centrifuge.on('error', (ctx) => {
    console.error('[realtime] error', ctx);
  });
  centrifuge.connect();
  // Expose for debugging
  if (typeof window !== 'undefined') {
    window.__centrifuge = centrifuge;
  }
  return centrifuge;
}

async function getSubscribeToken(channel) {
  const response = await api.post('/api/centrifugo/subscribe-token', { channel });
  // Interceptor handles unified structure, response.data is already unwrapped
  const token = response.data?.token || response.data;
  if (!token) throw new Error('No subscribe token');
  return token;
}

export async function subscribeChannel(channel) {
  const client = await ensureClient();
  if (channelSubs.has(channel)) return channelSubs.get(channel);
  const token = await getSubscribeToken(channel);
  const sub = client.newSubscription(channel, {
    token,
    getToken: async () => {
      try {
        const r = await api.post('/api/centrifugo/subscribe-token', { channel });
        // Interceptor handles unified structure, response.data is already unwrapped
        return r.data?.token || r.data;
      } catch (e) {
        console.error('[realtime] get sub token error', channel, e);
        return null;
      }
    }
  });
  sub.on('publication', (ctx) => {
    const evt = ctx.data;
    if (!evt || !evt.type) return;
    emitter.emit(evt.type, evt.data);
  });
  sub.on('subscribed', () => {
    console.log('[realtime] subscribed', channel);
  });
  sub.on('error', (ctx) => {
    console.error('[realtime] subscription error', channel, ctx);
  });
  sub.subscribe();
  channelSubs.set(channel, sub);
  return sub;
}

export function unsubscribeChannel(channel) {
  const sub = channelSubs.get(channel);
  if (sub) {
    try { sub.unsubscribe(); } catch (_) {}
    channelSubs.delete(channel);
  }
}

export function on(event, handler) {
  emitter.on(event, handler);
  return () => emitter.off(event, handler);
}

export async function ensureUserChannel(userId) {
  return subscribeChannel(`user:${userId}`);
}


